<template>
  <NuxtLayout name="default">
    <template #menu>
      <div v-if="pending">
        ...
      </div>
      <p v-else-if="error">
        {{ error }}
      </p>
      <div v-else>
        <li class="menu-title">
          <span>Deine Texte</span>
        </li>
        <template v-for="text in dataSorted"
                  :key="text.id">
          <li>
            <NuxtLink :to="`/write/${text.id}`"
                      activeClass="active">
              {{ text.title }}
            </NuxtLink>
          </li>
        </template>
      </div>
    </template>
    <slot />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useNuxtApp } from "nuxt/app";
const { $surrealRawQuery, $surrealLive } = useNuxtApp()

// const { data, error, pending } = $surrealQuery('SELECT id, title FROM texts')
const data = ref([]);
const { ready, error, pending, close } = $surrealLive('texts', (action: string, result) => {
  switch (action) {
    case 'CLOSE':
      // TODO: Reconnect?
      console.warn('Connection closed, reconnecting...')
      break;
    //
    case 'CREATE':
      data.value.push(result);
        break;
    case 'UPDATE':
      const index = data.value.findIndex(item => item.id.id === result.id.id);
      if (index !== -1) {
        data.value[index] = result;
      }
      break;
    case 'DELETE':
    const indexDelete = data.value.findIndex(item => item.id.id === result.id.id);
      if (indexDelete !== -1) {
        data.value.splice(indexDelete, 1);
      }
      break;
  }
})

// Load the 'normal' values
ready.then(() => $surrealRawQuery('SELECT id, title FROM texts WHERE user = $auth.id') // TODO is this WHERE-clause needed (for performance) or not because of RBAC?
  .then((res) => {
    if (Array.isArray(res) && Array.isArray(res[0])) {
      data.value.push(...res[0]);
    }
  })
  .catch((err) => {
    error.value = err;
  }));

const dataSorted = computed(() => {
  return data.value.sort((a, b) => a.title.localeCompare(b.title))
})

</script>
